import { HdRbacButton } from "../../../../components"
import { RbacPermissions } from "../../../../core/interfaces/user"

export const CreateVPCPeeringButton = ({onClick}: {onClick: () => void}) => {
  
  return (
    <div>
      
      <HdRbacButton dataId='create-vpc-peering-button' rbacPermission={RbacPermissions.PIPELINE_CREATE} icon='plus' onClick={onClick}>
        Create VPC Peering
      </HdRbacButton>
    </div>
  )
} 